/* @flow */
import UserProfileView from './UserProfileView';

export default UserProfileView;
